import { createContext, useContext } from "react";

/** Keep the originating workspace mounted while a contextual record is in front. */
export const SurfaceSuspensionContext = createContext(false);
export function useSurfaceSuspended() { return useContext(SurfaceSuspensionContext); }
